import { useTranslation } from 'react-i18next';
import { ERecommendationVariant } from '../constans/report';
import { THEME as theme } from '../styles/theme';

export const useRecommendations = () => {
  const {t} = useTranslation();

  const getVariantDetails = (variant: ERecommendationVariant) => {
    switch (variant) {
      case ERecommendationVariant.SHOULD:
        return {
          title: t('report.recommendation.youShouldImprove'),
          color: theme.colors.accent.red[100]
        };
      case ERecommendationVariant.COULD:
        return {
          title: t('report.recommendation.youCouldImprove'),
          color: theme.colors.accent.orange[100]
        };
      case ERecommendationVariant.EXCEL:
        return {
          title: t('report.recommendation.youExcelAt'),
          color: theme.colors.accent.green[100]
        };
      case ERecommendationVariant.OTHER:
        return {
          title: t('report.recommendation.other'),
          color: theme.colors.accent.violet[100]
        };
    }
  };

  return { getVariantDetails };
};
